DJ.addBehavior('recettes_form', '.recettes_form', {
  attach: function(context, settings, behavior) {

    const selectors = [
      'edit-field-type-recette-target-id',
      'edit-field-format-target-id'
    ];

    // Déterminer le contexte (MAG ou recettes)
    const isRecettesPage = document.querySelector('.view-id-recettes') !== null;
    const isMagPage = document.querySelector('.view-id-articles') !== null;

    // Labels pour aria-labelledby selon le contexte
    const getOptionLabel = function(optionText, selector) {
      if (isMagPage && selector === 'edit-field-format-target-id') {
        // Pour le MAG, utiliser "Article" comme label
        return 'Article';
      }
      if (isRecettesPage && selector === 'edit-field-format-target-id') {
        // Pour recettes, utiliser le texte de l'option (Entrée, Plat, Dessert)
        return optionText;
      }
      if (isRecettesPage && selector === 'edit-field-type-recette-target-id') {
        // Pour le type de recette, utiliser le texte de l'option
        return optionText;
      }
      return optionText;
    };

    once('toggle-open',
      selectors
        .map(sel => `.recettes_form [data-drupal-selector="${sel}"]`)
        .join(',')
    ).forEach(el => {
      const combobox = el.querySelector('button.fieldset-legend-combobox');
      const listbox = el.querySelector('.fieldset-wrapper[role="listbox"]');

      if (!combobox || !listbox) return;

      // Initialiser les attributs ARIA sur les options (les labels)
      const options = listbox.querySelectorAll('label.option');
      options.forEach((option, index) => {
        // Extraire le texte de l'option (sans le count si présent)
        let optionText = option.textContent.trim();
        // Enlever le count si présent
        const countElement = option.querySelector('.count');
        if (countElement) {
          optionText = optionText.replace(countElement.textContent, '').trim();
        }

        // Normaliser le texte pour créer un ID (Article, Entrée, Plat, Dessert)
        const normalizedText = optionText
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // Enlever les accents
          .replace(/[^a-zA-Z0-9]/g, '-')
          .toLowerCase();

        // Créer un ID unique pour chaque option
        const optionId = listbox.id + '-option-' + normalizedText;
        if (!option.id) {
          option.id = optionId;
        }

        // Créer un span avec le texte de l'option pour aria-labelledby
        // Ce span servira de référence pour aria-labelledby
        let labelSpan = option.querySelector('.option-label-text');
        if (!labelSpan) {
          labelSpan = document.createElement('span');
          labelSpan.className = 'option-label-text visually-hidden';
          labelSpan.id = optionId + '-text';
          labelSpan.textContent = optionText;
          // Insérer le span au début du label (avant le texte visible)
          const checkbox = option.previousElementSibling;
          if (checkbox && checkbox.classList.contains('form-checkbox')) {
            // Insérer après la checkbox mais avant le texte visible
            option.insertBefore(labelSpan, option.firstChild.nextSibling);
          } else {
            option.insertBefore(labelSpan, option.firstChild);
          }
        }

        // Pour les options de la listbox, aria-labelledby doit pointer vers le span avec le texte
        // Selon le brief : "Article" pour MAG, "Entrée"/"Plat"/"Dessert" pour recettes
        option.setAttribute('role', 'option');
        option.setAttribute('aria-labelledby', labelSpan.id);
      });

      // Fonction pour basculer l'état
      const toggleCombobox = function(isOpen) {
        if (isOpen) {
          el.classList.add('open');
          combobox.setAttribute('aria-expanded', 'true');
        } else {
          el.classList.remove('open');
          combobox.setAttribute('aria-expanded', 'false');
        }
      };

      // Gestion du clic sur le combobox
      combobox.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const isCurrentlyOpen = el.classList.contains('open');
        toggleCombobox(!isCurrentlyOpen);
      });

      // Gestion du clavier - s'assurer que le legend reçoit bien les événements
      combobox.addEventListener('keydown', function(e) {
        // Enter ou Espace pour ouvrir/fermer
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          const isCurrentlyOpen = el.classList.contains('open');
          toggleCombobox(!isCurrentlyOpen);
        }
        // Escape pour fermer
        else if (e.key === 'Escape' && el.classList.contains('open')) {
          e.preventDefault();
          e.stopPropagation();
          toggleCombobox(false);
          combobox.focus();
        }
        // Flèches pour navigation (optionnel, pour améliorer l'UX)
        else if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !el.classList.contains('open')) {
          e.preventDefault();
          e.stopPropagation();
          toggleCombobox(true);
        }
      });

      // Gestion du focus - ouvrir le combobox au focus clavier
      combobox.addEventListener('focus', function() {
// Ouvrir le combobox au focus (pour l'accessibilité clavier)
        if (!el.classList.contains('open')) {
          toggleCombobox(true);
        }
      });

      // Fermer si le focus sort du composant
      el.addEventListener('focusout', function(e) {
        setTimeout(function() {
          // Vérifier si le focus est toujours dans le composant
          const activeElement = document.activeElement;
          const isFocusInComponent = el.contains(activeElement) || activeElement === combobox;
          if (!isFocusInComponent && el.classList.contains('open')) {
            toggleCombobox(false);
          }
        }, 0);
      });
    });

    document.querySelectorAll('.recettes_form').forEach(form => {

      const legendLabels = {
        'edit-field-type-recette-target-id': 'Types',
        'edit-field-format-target-id': 'Format',
      };

      updateForm();

      // Masquer le bouton reset si un filtre est coché au chargement.
      const resetLink = document.querySelector('.js-form-reset');
      if (resetLink) {
        const hasChecked = document.querySelector('.bef-exposed-form input[type="checkbox"]:checked');
        if (!hasChecked) {
          resetLink.classList.add('hidden');
        } else {
          resetLink.classList.remove('hidden');
        }
      }

      function updateForm() {
        selectors.forEach(selector => {

          const wrapper = form.querySelector(`[data-drupal-selector="${selector}"]`);
          if (!wrapper) return;

          const legend = wrapper.querySelector('.fieldset-legend');
          if (!legend) return;
          const namePrefix = selector
            .replace('edit-', '')
            .replace(/-/g, '_');
          const checkboxSelector = `input[name^="${namePrefix}"]:checked`;
          const checked = wrapper.querySelectorAll(checkboxSelector);
          const label = legendLabels[selector] || 'Filtre';

          if (checked.length > 0) {
            // Trouver le span fieldset-legend existant
            const labelSpan = legend.querySelector('span.fieldset-legend');
            if (labelSpan) {
              // Mettre à jour le contenu du span existant avec le label, le count et le visually-hidden
              labelSpan.innerHTML = `${label}<span class="count">${checked.length}</span><span class="visually-hidden">élément sélectionnés</span>`;
            } else {
              // Fallback si la structure n'est pas celle attendue
              legend.innerHTML =
                `<span class="fieldset-legend">${label}<span class="count">${checked.length}</span><span class="visually-hidden">élément sélectionnés</span></span>`;
            }
          } else {
            // Supprimer le span visually-hidden si présent (il devrait être dans le labelSpan)
            const labelSpan = legend.querySelector('span.fieldset-legend');
            if (labelSpan) {
              // Supprimer le visually-hidden s'il existe dans le labelSpan
              const hiddenSpan = labelSpan.querySelector('span.visually-hidden:not([id*="combobox-label"])');
              if (hiddenSpan) {
                hiddenSpan.remove();
              }
              labelSpan.innerHTML = label;
            } else {
              legend.innerHTML = label;
            }
          }
        });
      }

      form.addEventListener('change', updateForm);
    });
  },

  detach: function() {}
});
